/* eslint-disable import/named */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { parseISO } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Calendar } from 'react-date-range';
import { withRouter, useLocation } from 'react-router-dom';
import moment from 'utils/moment';
import Modal from '../modal';
import scheduleStyle from '../../modules/Badging/Scheduling/Scheduling.module.scss';
import styles from './detail.module.scss';
import badgeStyles from '../../modules/Badging/Detail/detail.module.scss';
import PERMITMODULE from '../../icons/PERMITMODULE.png';
import SectionHeader from '../sectionHeader';
import HeaderBack from '../headerBack';
import Panel from '../panel';
import Button from '../button/button';
import Loading from '../loading';
import Clickable from '../clickable/Clickable';
import Collapsible from '../collapsible/Collapsible';
import { renderInfoForType } from '../../utils/helpers';
import { ADP_Re_Print, AVP_Re_Print, fetchSchedules, cancelApplication, scheduleAppointment,
  reScheduleAppointment, actionGetBookingSchedules, fetchScheduleSlotsByDate,
  updateRequiredDocuments, uploadAvpAttachments, clearState, makeAdpPayment,
  clearCancelState, clearScheduleSlotsAction, clearReprintState,
  initiateApplication, clearAdpDetailsStatus, makeAvpPayment } from '../../modules/PermitManagement/redux/action';
import AttachmentDetail from '../../modules/forms/components/AttachmentDetail';
import DetailsStatus from '../../modules/PermitManagement/ADP/Logs/detail/Status';
import SuspendRevokeComp from '../../modules/PermitManagement/components/SuspendRevokeComp';
import PulpoField from '../../pulpo_visualizer/fields';
import PermitFieldDetails from '../../modules/PermitManagement/components/PermitFieldDetails';
import permitStyle from '../../modules/PermitManagement/components/permitDetail.module.scss';
import FormattedMessageWithClass from '../formattedMessageWithClass';
import { UpdateRequiredDocuments, UploadAvpDocuments } from '../../modules/PermitManagement/components/ActionCompo';
import { GetFileName, S3Uploads } from '../../modules/services';
import FileSlider from '../photoCarousel/FileSlider';
import PaymentPage from '../../modules/PermitManagement/ADP/Components/PaymentPage';
import Checkbox from '../checkbox';
import { carryForwardAttachments, filterCustomFieldAnswers, getAttachmentIds } from '../../modules/PermitManagement/components/PermitData';
import TnsPaymentModal from '../../modules/PermitManagement/ADP/MyApplications/components/TnsPaymentModal';

const Detail = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { myApplication } = location?.state || false;
  const printRef = React.useRef(null);

  // CANCEL PERMIT BEFORE GENERATING BADGE
  const canclletionStatus = [2, 11, 6, 15];
  const { logData, firstHeaders, lastHeaders, tableHeaders, panelname, backRoute, actionsBtn, history: { push }, match, actionPending, defaultIDs,
    adpDetails, avpDetailsPage, getLatestAvpDetails, handleGetLatestADPDetails, adpHistory, allFields, order, settings, logId, invoiceObject,
    adpComments, handleComments, isRejected = false, paymentByTenant, cancellationFee, rePrintList = [], renewal_data = {}, category,
    hasOfflinePayment, tnsPaymentModal = false } = props;
  const dateFormate=useSelector(state => state?.auth?.profile?.portal_airport?.airport_settings?.date_format) || 'MM/DD/YYYY';
  const actionScheduleFetch= useSelector(state => state?.permitManagement?.actionScheduleFetch);
  const profile = useSelector(state => state?.auth?.profile);
  const updateRequiredDocumentsAction = useSelector(state => state?.permitManagement?.updateRequiredDocumentsAction);
  const { adpAvpCancelAplicationAction, cancellationResponse } = useSelector(state => state?.permitManagement);
  const scheduleList = useSelector(state => state?.permitManagement?.scheduleList);
  const scheduleSlots = useSelector(state => state?.permitManagement?.scheduleSlots);
  const actionScheduled = useSelector(state => state?.permitManagement?.actionScheduled);
  const uploadAvpDocumentsAction = useSelector(state => state?.permitManagement?.uploadAvpDocuments);
  const actionRescheduled = useSelector(state => state?.permitManagement?.actionRescheduled);
  const actionScheduleSlotsFetch = useSelector(state => state?.permitManagement?.actionScheduleSlotsFetch);
  const suspendAction = useSelector(state => state?.permitManagement?.suspendApplicationAction);
  const revokeAction = useSelector(state => state?.permitManagement?.revokeAVPApplicationAction);
  const permitCategory = useSelector(state => state.permitManagement?.specificLog?.category_of_adp);
  const paymentActionStatus = useSelector(state => state?.permitManagement?.makeAdpPaymentAction);
  const avpPaymentStatus = useSelector(state => state?.permitManagement?.getAvpPaymentAction);
  const adpRePrintStatus = useSelector(state => state?.permitManagement?.adpRePrintStatus);
  const avpRePrintStatus = useSelector(state => state?.permitManagement?.avpRePrintStatus);
  const actionPortalTrainingsFetch = useSelector(state => state?.permitManagement?.actionPortalTrainingsFetch);
  const paymentRedirectUrl = useSelector(state => state?.permitManagement?.paymentRedirectUrl);
  const isTnsPaymentTrackingEnable = profile?.portal_airport?.airport_settings?.payment_tracking === 'TNS';
  const permitCategories = logData?.settings?.category_based_skill_test_setting;
  const [actionsShow, setActionsShow] = useState(false);
  const [blockedDate, setBlockedDate] = useState([]);
  const [startTimeInMinutes, setStartTimeInMinutes] = useState([]);
  const [endTimeInMinutes, setEndTimeInMinutes]= useState([]);
  const [blockedDates, setBlockedDates]= useState([]);
  const [cancelDetails, handleCancelDetails] = useState({ openCancelPopup: false, cancelRemarks: '', cancelShowError: false });
  const [rePrintModal, setModal]= useState(false);
  const [refundPopup, setRefundPopup] = useState(false);
  const [viewReceipts, setViewReceipts] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [reprintPaymentModal, setReprintPaymentModal] = useState(false);
  const [tnsPaymentUrl, handleTnsPaymentUrl] = useState('');
  const [activeId, setActiveId] = useState({ reprint_info: {}, selectedId: null });
  const [scheduleModal, setScheduleModal] = useState(false);
  const [reSchedule, setReschedule] = useState(false);
  const [init, setInit] = useState({ modal: true, noSlot: false, payModal: true, reprintPayModal: true });
  const [checkRefund, setCheckRefund] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [updateDocumentsDate, setUpdateDocumentsDate] = useState(false);
  const [expiringAttachments, setExpiringAttachments] = useState([]);
  const [offlineModal, setOfflineModal] = useState(false);
  const [isAttachmentsPreview, setIsAttachmentsPreview] = useState(false);
  const [updateDocumentsModal, setUpdateDocumentsModal] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [updateDocuments, setUpdateDocuments] = useState({ openDocumentModal: false,
    removed_attachements: [],
    photo: [],
    response: {},
    custom_errors: {},
    document_errors: {},
    req_attachments_details: {} });
  const [uploadDocuments, setUploadDocuments] = useState({
    attachments: logData?.attachments || [],
    response: logData?.response || {},
    removed_attachments: [],
    custom_errors: {}
  });
  const [docModal, setDocModal] = useState(false);
  const [actionDetails, handleActionDetails] = useState({
    suspend: {},
    suspendErrors: {
      suspend_type_select: true,
      suspend_untill_date: true,
      suspendRemarks: true
    }
  });
  const application_Status = logData?.status || false;
  const initialState = {
    selected_date: new Date(),
    selected_time_slot: '',
    useCalendarData: {},
    available_time_slots: [],
    person_details: {},
    dataError: false,
    useDisableDates: []
  };
  const [schedule_data, handleScheduleData] = useState(initialState);
  const [apiSuccessMsg, handleApiStatus] = useState({ apiSuccessMessage: '', apiSuccess: false, loading: false });
  const [fieldErrors, handleFieldError] = useState({
    useFieldError: false
  });
  const [reOrder, setReOrder] = useState([]);

  // -------------------------------- for renewal the form ----------------------------------------------
  const [renewalFlow, setRenewalFlow] = useState({ init: false, loader: false, appID: null, popup: false, renewal: false, reDirect: false });
  const renewalApplication = logData;
  const { adpSchema, customField, oldCustomFields } = renewal_data;
  const adpInitiationStatus = useSelector(states => states.permitManagement.adpInitiationStatus);

  const handelSubmit = async () => {
    const data = {
      application_type: 'Renewal',
      designation: renewalApplication?.designation ? renewalApplication?.designation : '',
      email: renewalApplication?.email ? renewalApplication?.email : '',
      phone: renewalApplication?.phone ? renewalApplication?.phone : '',
      first_name: renewalApplication?.first_name ? renewalApplication.first_name : '',
      last_name: renewalApplication?.last_name ? renewalApplication.last_name : '',
      use_prev_badge: false,
      offline_training: false,
      prev_permit: renewalApplication?.id ? renewalApplication?.id : null,
      prev_badge_no: null
    };
    if (data?.phone) {
      data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
    }

    if (renewalApplication?.initiated_to) {
      data.initiated_to = renewalApplication?.initiated_to?.id;
    }
    // ----------- Forward Attachments to Renewal Application -----------
    const attachmentData = {
      req_attachments: renewalApplication?.req_attachments || {},
      req_attachments_details: renewalApplication?.req_attachments_details || {},
      photo: renewalApplication?.photo
    };
    const newRequiredAttachments = adpSchema?.default_fields?.required_attachements || [];

    const filteredAnswers = await filterCustomFieldAnswers(oldCustomFields, customField, renewalApplication?.response);
    const filteredResponse = await getAttachmentIds(filteredAnswers);

    const updatedData = await carryForwardAttachments(attachmentData, newRequiredAttachments, renewalApplication);

    data.req_attachments = updatedData.req_attachments;
    data.req_attachments_details = updatedData.req_attachments_details;
    data.attachments = updatedData.attachments;
    data.photo = updatedData.photo;
    data.response = filteredResponse;
    data.signature = [];
    // ----------- Forward Attachments to Renewal Application -----------

    await dispatch(initiateApplication(data));
  };

  useEffect(() => {
    if (renewalFlow.init && renewalFlow.appID) {
      setRenewalFlow(prev => ({ ...prev, renewalFlow: false, appID: null, renewal: true }));
    }
  }, [renewalFlow.init, renewalFlow.appID, dispatch]);

  useEffect(() => {
    if (renewalFlow.renewal) {
      setTimeout(() => {
        handelSubmit();
        dispatch(clearAdpDetailsStatus());
        setRenewalFlow(prev => ({ ...prev, loader: false, renewal: false }));
      }, 500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renewalFlow.renewal]);

  useEffect(() => {
    if (adpInitiationStatus?.success) {
      handleGetLatestADPDetails();
      dispatch(clearState());
      setRenewalFlow(prev => ({ ...prev, reDirect: true }));
    }
  }, [adpInitiationStatus, dispatch, handleGetLatestADPDetails]);

  const handleSubmitRenewalForm = (ID) => {
    setRenewalFlow({ init: true, loader: true, appID: ID, popup: false });
  };

  const handleRenewalConfirmation = (ID) => {
    setRenewalFlow(prev => ({ ...prev, appID: ID, popup: true }));
  };

  const handleCloseRenewPopup = () => {
    setRenewalFlow({ init: false, loader: false, appID: null, popup: false, renewal: false });
  };

  const handleCloseRedirect = () => {
    setRenewalFlow(prev => ({ ...prev, reDirect: false }));
  };

  // -------------------------------- for renewal the form ----------------------------------------------

  useEffect(() => {
    if (allFields?.length && order?.length) {
      const newIDs = allFields?.filter(e => !e?.isDisabled
        && e?.id !== 'signature'
        && e.type !== 'header').map(i => i.id);
      setReOrder(order?.filter(id => newIDs?.includes(id)));
    }
  }, [logData, allFields, order]);

  useEffect(() => {
    if (actionScheduleSlotsFetch.loading === true) {
      setLoadingStatus(true);
    }
    if (actionScheduleSlotsFetch.success === true) {
      setLoadingStatus(false);
    }
  }, [actionScheduleSlotsFetch]);

  useEffect(() => {
    if (paymentActionStatus?.success || paymentActionStatus?.error || avpPaymentStatus?.success || avpPaymentStatus?.error) {
      setLoadingStatus(false);
      setPaymentModal(false);
      setOfflineModal(false);
      dispatch(clearState());
    }
  }, [paymentActionStatus, dispatch, avpPaymentStatus]);

  useEffect(() => {
   if (paymentActionStatus?.success && paymentRedirectUrl && isTnsPaymentTrackingEnable) {
        handleTnsPaymentUrl(paymentRedirectUrl);
      }
  }, [paymentActionStatus, paymentRedirectUrl, isTnsPaymentTrackingEnable]);


  const { selected_time_slot, useCalendarData, airportData, available_time_slots,
    utcSlotStartDate, utcSlotEndDate, useDisableDates } = schedule_data;
  const duration_slot = useCalendarData?.settings?.schedule_duration === '1' ? 60 : Number(useCalendarData?.settings?.schedule_duration);
  const scheduleBasedCategory = useCalendarData?.settings?.advanced_settings?.filter(ele => ele.schedule_category === permitCategory);
  let slot_duration;
   if (scheduleBasedCategory && scheduleBasedCategory.length>0) {
    slot_duration = scheduleBasedCategory[0]?.schedule_duration;
  } else {
    slot_duration = duration_slot;
  }

  const handleCheckPastSlotsOftheDay = (selectedVal, startVal) => {
    if (moment(selectedVal).isAfter(moment(), 'day')) {
      return true; // FOR FUTURE DATES NO NEED TO CHECK PAST SLOTS OF THE DAY
    }
    return startVal.isSameOrAfter(moment());
  };

  const createTimeSlots = (fromTime, toTime, slotDuration, calDate) => {
    let startTime = moment(fromTime, 'HH:mm');
    const endTime = moment(toTime, 'HH:mm');
    const slotList = [];
    const verifyTests = verifyNumberOfTests();
    if (verifyTests) {
      while (
        startTime.isSame(endTime) || startTime.isBefore(endTime)
      ) {
        if (slotDuration === undefined || Number.isNaN(slotDuration)) {
          break;
        }
        const endTimeCheck = moment(toTime, 'HH:mm').subtract(slotDuration, 'minute');

        if (
          (startTime.isSame(endTimeCheck) || startTime.isBefore(endTimeCheck))
          && calDate && handleCheckPastSlotsOftheDay(calDate, startTime)
        ) {
          slotList.push(startTime.format('HH:mm'));
        }

        startTime = startTime.add(slotDuration, 'minute');
      }
    }
    return slotList;
  };

  const verifyNumberOfTests = () => {
    if (scheduleBasedCategory && scheduleBasedCategory.length>0 &&scheduleSlots?.length>0 && permitCategory) {
      const scheduleBased = scheduleSlots.filter(ele => ele.adp_info?.category === permitCategory);
      if (Number(scheduleBased?.length) >= Number(scheduleBasedCategory[0]?.schedule_tests)) {
        return false;
      }
    }
    return true;
  };

  function getDayIndex(weekday) {
    const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return weekdays.indexOf(weekday);
  }

  const convert12to24= (time12h) => {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
        hours = '00';
    }
    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
};
  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handledisableTime =(date, blockTimes) => {
    const convertedTimes = blockTimes.map((time) => {
     if (time.start_time && moment(time.block_date).format('l') === moment(date).format('l')) {
     return {
         start_time: time?.start_time.label.includes('AM')
         || time.start_time.label.includes('PM') ? convert12to24(time.start_time.label) : time.start_time.label,
         end_time: time?.end_time.label.includes('AM')
          || time.end_time.label.includes('PM') ? convert12to24(time.end_time.label) : time.end_time.label,
        blockDate: time.block_date
     };
   }
     return {};
    });
    let removeempty =convertedTimes.filter(ele => Object.keys(ele).length !== 0) || [];
    if (removeempty && removeempty?.length > 0) {
     removeempty.forEach((item) => {
       const startTime = item.start_time;
       const endTime = item.end_time;
       setBlockedDates(prev => [...prev, item.blockDate]);
       setStartTimeInMinutes(prevStartTimes => [...prevStartTimes, timeToMinutes(startTime)]);
       setEndTimeInMinutes(prevEndTimes => [...prevEndTimes, timeToMinutes(endTime)]);
   });
}
   };

  const handleGetAvailbleDates = (weekday, selectedMonth) => {
    const today = new Date(selectedMonth);
    const currentMonth = today.getMonth();
    const dates = [];
    const targetDay = getDayIndex(weekday);
    // Set the date to the first day of the current month
    today.setDate(1);
    while (today.getMonth() === currentMonth) {
      if (today.getDay() === targetDay) {
        // If the current day is the target day, add it to the array
        dates.push(new Date(today));
      }
      today.setDate(today.getDate() + 1);
    }
    return dates;
  };

  const handleCalenderDates = (week_info, currentMonth) => {
    let unavaialbleDates = [];
    if (week_info) {
      Object.keys(week_info).forEach((eachWeek) => {
        if (week_info[eachWeek]?.length === 0) {
          unavaialbleDates = [...unavaialbleDates, ...handleGetAvailbleDates(eachWeek, currentMonth)];
        }
      });
    }
    return unavaialbleDates;
  };

  const handleMyApplicationSchedule = () => {
    let twentyFourHours = false;
    if (myApplication) {
      let createdDate = props?.logData?.work_flow?.booking?.start_ts;

      let dateCreated = new Date(createdDate); // Directly create Date object
      let now = new Date();

      // Check if there is at least 24 hours of future time between now and createdDate
      if (dateCreated.getTime() - now.getTime() >= 24 * 60 * 60 * 1000) {
          twentyFourHours = true;
      }
    }
    return twentyFourHours;
  };


  useEffect(() => {
    if (adpDetails && logData && init.modal && logData?.status === 11) {
      if ((myApplication && handleMyApplicationSchedule())
        || logData?.work_flow?.booking?.status === 'cancelled') {
        setScheduleModal(true);
        setReschedule(true);
        setInit(prev => ({ ...prev, modal: false }));
      } else if (logData?.settings?.scheduleEnable
        && !(logData?.work_flow?.booking?.status === 'cancelled')) {
        setScheduleModal(true);
        setInit(prev => ({ ...prev, modal: false }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adpDetails, logData, myApplication, init.modal]);

  const checkReprintRequest = useCallback(() => {
    const reprintRequests = logData?.reprint_requests || [];
    return reprintRequests.some(request => request.status === 2);
  }, [logData]);


  useEffect(() => {
    if (!init.payModal) return;

    const isValidPayment = logData?.status === 10 || (
      logData?.payment_stage === 'on_reprint_application'
        && checkReprintRequest()
        && logData?.status === 3
      ) || (logData?.status === 4 && logData?.reject_payment);

    const hasPayment = settings?.enablePermitFees
      && (adpDetails || avpDetailsPage)
      && paymentByTenant
      && isValidPayment;

    if (!hasPayment) return;

    if (hasOfflinePayment) {
      setOfflineModal(true);
    } else {
      setPaymentModal(true);
    }
    setInit(prev => ({ ...prev, payModal: false }));
  }, [adpDetails, avpDetailsPage, logData, init.payModal, paymentByTenant,
    settings, checkReprintRequest, hasOfflinePayment
  ]);

  useEffect(() => {
    if (!adpRePrintStatus?.success && !avpRePrintStatus?.success) return;

    if (adpDetails && adpRePrintStatus?.success) handleGetLatestADPDetails();
    if (avpDetailsPage && avpRePrintStatus?.success) getLatestAvpDetails();

    dispatch(clearReprintState());
  }, [adpRePrintStatus, avpRePrintStatus,
    adpDetails, avpDetailsPage, dispatch,
    handleGetLatestADPDetails, getLatestAvpDetails
  ]);


  const handleDateChange = async (useCalendarData2, airportData2, date, getLoading) => {
    if (getLoading) handleApiStatus({ ...apiSuccessMsg, loading: true });
    let s = new Date(date);
    let f = new Date(date);
    s.setHours(0, 0, 0, 0);
    f.setHours(24, 59, 59, 99);
    s = s.toISOString();
    f = f.toISOString();
    let weekDay= moment(date).format('ddd');
    weekDay = weekDay.toUpperCase();
    await dispatch(fetchScheduleSlotsByDate(useCalendarData2.id, s, f));
    let week_availablity_info = useCalendarData2?.settings?.week_availablity_info;
    if (useCalendarData2?.settings?.advanced_settings?.length > 0) {
      week_availablity_info = useCalendarData2?.settings?.advanced_settings?.find(cate => cate.schedule_category === permitCategory)
      ?.week_availablity_info || {};
    }
    const useAvailablityList = week_availablity_info?.[weekDay] || [];
    let getSlots = [];
    useAvailablityList.map((eachT) => {
      const takeSlot = createTimeSlots(eachT?.from?.value, eachT?.to?.value, slot_duration, date);
      getSlots = [...getSlots, ...takeSlot];
      return eachT;
    });
    const timeObjects = getSlots.map(time => new Date(`1970-01-01T${time}`));
    timeObjects.sort((a, b) => a - b);
    const sortedTimeSlots = timeObjects.map(time => time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));
    setLoadingStatus(true);
    const disableDates = handleCalenderDates(week_availablity_info, date);
    let datecheck = useCalendarData?.settings?.blocked_details?.map(ele => ele.start_time && moment(ele.block_date).format('l'));
    if (datecheck?.includes(moment(date).format('l'))) {
      handledisableTime(date, useCalendarData?.settings?.blocked_details);
     } else {
      setStartTimeInMinutes('');
      setEndTimeInMinutes('');
      setBlockedDate([]);
     }
    handleScheduleData({ ...schedule_data,
      selected_date: date,
      available_time_slots: sortedTimeSlots,
      dataError: false,
      useCalendarData: useCalendarData2, // check this 2 lines
      airportData: airportData2,
      person_details: {},
      useDisableDates: disableDates,
      selected_time_slot: ''
    });
    handleApiStatus({ ...apiSuccessMsg, loading: false });
  };

  const handelReprint = (id) => {
    const data = {
      reprint_info: {
        feeDetails: activeId?.reprint_info || {},
        applicationFor: 'on_reprint_application',
        selectedCategory: category
      }
    };
    if (match.path.includes('avp')) {
      dispatch(AVP_Re_Print(id, data));
    } else if (match.path.includes('adp')) {
      dispatch(ADP_Re_Print(id, data));
    }
    setModal(false);
  };

  const handleSaveUpload = () => {
    const payload = {
      calender: schedule_data?.useCalendarData?.id,
      start_ts: utcSlotStartDate,
      end_ts: utcSlotEndDate
    };
    const noErrors = fieldErrors && Object.keys(fieldErrors)?.every(k => (fieldErrors[k] === false));
    if (noErrors && payload.start_ts && !reSchedule) {
      setLoadingStatus(true);
      dispatch(scheduleAppointment(match.params.id, payload));
    } else if (noErrors && payload.start_ts && reSchedule) {
      setLoadingStatus(true);
      dispatch(reScheduleAppointment(match.params.id, payload));
    } else if (payload.start_ts === undefined) {
      handleScheduleData({ ...schedule_data, dataError: true });
    } else {
      handleFieldError({
        ...fieldErrors,
        useFieldError: true
      });
    }
  };

  const dateFields = ['approved_on', 'created_at', 'suspended_at', 'updated_at', 'violation_at',
  'reversed_at', 'valid_until', 'defect_at', 'dob', 'lic_issue_date', 'payment_date',
  'insurance_validity', 'pc_validity', 'training_completed_at', 'avp_validity'];

  const hasTime = (value) => {
    if (typeof value !== 'string') return false;
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);
  };

  const getRow = (headers) => {
    let defaultFieldTitles ={};
    if (logData && logData.schema?.default_fields?.default_field) {
      logData.schema.default_fields.default_field.forEach((field) => {
        if (!field.isDisabled) {
        defaultFieldTitles[field.id] = field.title;
        }
      });
    }
    const result = headers.map((ele) => {
      if (ele[0] === 'comment' && logData.comment!== null) {
        return (
          <div className={styles.infoRow} style={{ width: '100%' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || [ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {logData?.[ele[0]]}
            </span>
          </div>
        );
      }
      if (ele[0] === 'comment') {
        return '';
      }
      if (ele[0]==='quantum_points') {
        return (
          <div className={styles.infoRow} style={{ width: '100%' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || [ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {logData?.[ele[0]]||logData?.additional_info?.quantum_points||logData?.vehicle_info?.quantum_points}
            </span>
          </div>
        );
      }
      if (ele[0] === 'attachments' || ele[0]==='signature') {
        return (
          <div className={styles.infoRow} style={{ width: '100%', height: 'fit-content' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || ele[1]}
              />
            </span>
            {logData?.[ele[0]]?.length > 0 && (
            <div style={{ width: '550px', overflow: 'scroll hidden' }}>
              <AttachmentDetail
                attachments={logData?.[ele[0]]}
              />
            </div>)}
          </div>
        );
      }
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={defaultFieldTitles[ele[0]] || [ele[1]]}
              />
            </span>
            <span className={styles.rowContent}>
              {(() => {
                const key = ele[0];
                const value = logData?.[key];
                if (key === 'renewal_date' || key === 'lic_exp_date') {
                  return value ? `${moment(value).format(dateFormate)} 11:59 PM` : '';
                }
                if (dateFields.includes(key)) {
                  return value ? renderInfoForType({ type: hasTime(value) ? 'datetime' : 'date' }, value) : '';
                }
                let res = value ?? '';
                if (['length', 'width', 'height', 'tpaa', 'tpao'].includes(key)) {
                  res += ' meters';
                }
                return res;
              })()}
            </span>
          </div>
        );
    });
    return result;
  };


  const getCustomRow = () => {
    const result = logData?.schema?.schema?.fields?.map(ele => ({ ...ele, value: logData?.response[ele.id] }));
    const customFields = result?.map((ele) => {
      if (ele.type==='select') {
        const res=ele.values.find(el => Number(el.key)===Number(ele.value));
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {res?.value}
            </span>
          </div>
        );
      }
      if (ele.type === 'datetime' || ele.type === 'date' || ele.type === 'time' || ele.type === 'only_time') {
        return (
          <div className={styles.infoRow}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {renderInfoForType(ele, ele?.value, result, true)}
            </span>
          </div>);
      }
      if (ele.type === 'multiselect') {
        let res = [];
        res = result?.find(e => e.id === ele.id);
        return (
          <div className={styles.infoRow} style={{ width: ele?.title.length > 28 && '100%' }}>
            <span className={styles.title}>
              <FormattedMessage
                id="module.detail"
                defaultMessage={ele?.title}
              />
            </span>
            <span className={styles.rowContent}>
              {ele?.value && ele?.value.map(val => (
                <>
                  <i key={val}>
                    {res?.values.find(e => e.key === val)
                      && res?.values.find(e => e.key === val).value}
                  </i>
                  <br />
                </>
              ))
            }
            </span>
          </div>
        );
      }
      if (ele.type === 'header') {
        return '';
      }
      return (
        <>
          {ele.type !== 'attachments' && (
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id="module.detail"
                  defaultMessage={ele?.title}
                />
              </span>
              <span className={styles.rowContent}>
                {ele?.value}
              </span>
            </div>
          )}
          {ele.type === 'attachments' && ele.value && (
            <>
              <AttachmentDetail
                attachments={ele.value}
                title={ele.title}
              />
            </>
          )}
        </>
      );
    });
    return customFields;
  };

  const handleActions = (section, actionType, value) => {
    handleActionDetails(prevSt => ({
      ...prevSt,
      [section]: {
        ...prevSt?.[section],
        [actionType]: value
      }
    }));
  };

  const handleAllStateValue = (state) => {
    handleActionDetails(state);
  };

  const getCurrentStage = () => {
    let statusTitle = 'pending';
    if (application_Status === 4) {
      statusTitle = 'Rejected';
    } if (application_Status === 3) {
      statusTitle = 'Approved';
    } if (application_Status === 8) {
      statusTitle = 'Suspended';
    } if (application_Status === 9) {
      statusTitle = 'Revoked';
    } if (application_Status === 11) {
      statusTitle = 'Pending Schedule';
    } if (application_Status === 15) {
      statusTitle = 'Application Withheld';
    }
    return statusTitle;
  };

  const handleCloseCancelPopup = useCallback(() => {
    handleCancelDetails({
      ...cancelDetails,
      openCancelPopup: false,
      cancelRemarks: '',
      cancelShowError: false
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancellationOfPermit = () => {
    let payload = {
      cancelled_reason: cancelDetails?.cancelRemarks
    };
    const feeAmount = Number((getFeeAmount()?.amount));
    const cancellationAmount = Number((cancellationFee?.grandTotal));
    const hasRefund = (adpDetails && settings?.enablePermitFees && paymentByTenant
      && feeAmount > 0 && cancellationAmount > 0 && feeAmount > cancellationAmount);
    const cancelRemarks = cancelDetails?.cancelRemarks?.trim();

    const shouldCancel = cancelRemarks && (
      (avpDetailsPage && !hasRefund)
        || (adpDetails
          && ((!hasRefund && !checkRefund) || (hasRefund && checkRefund) || (logData?.status === 3))));

    if (hasRefund && logData?.status !== 3) {
      payload.payment_details = {
        amount: Number((feeAmount - cancellationAmount).toFixed(2)),
        txnId: getFeeAmount()?.txn_id
      };
    }
    if (shouldCancel) {
      let cancelAppType = 'driver_permit';
      if (avpDetailsPage) {
        cancelAppType = 'vehicle_permit';
      }
      dispatch(cancelApplication(match?.params?.id, cancelAppType, payload));
    } else {
      handleCancelDetails({
        ...cancelDetails,
        cancelShowError: true
      });
    }
  };

  const handleOpenCancelModal = () => {
    handleCancelDetails({
      ...cancelDetails,
      openCancelPopup: true
    });
  };

  useEffect(() => {
    if (adpAvpCancelAplicationAction?.loading === false && adpAvpCancelAplicationAction?.success === true) {
      dispatch(clearCancelState());
      if (adpDetails && handleGetLatestADPDetails) {
        handleGetLatestADPDetails();
        handleCloseCancelPopup();
      }
      if (avpDetailsPage && getLatestAvpDetails) {
        getLatestAvpDetails();
        handleCloseCancelPopup();
      }
    }
  }, [adpAvpCancelAplicationAction, avpDetailsPage, adpDetails, handleGetLatestADPDetails, getLatestAvpDetails, handleCloseCancelPopup, dispatch]);

  useEffect(() => {
    if (adpDetails
      && adpAvpCancelAplicationAction?.success
      && Object.keys(cancellationResponse?.payment_response || {}).length > 0) {
      dispatch(clearCancelState());
      setRefundPopup(true);
    }
  }, [adpDetails, adpAvpCancelAplicationAction, cancellationResponse, dispatch]);

  const handleNavigate = (dateRange) => {
    const disableDates = handleCalenderDates(useCalendarData?.settings?.week_availablity_info, dateRange);
    handleScheduleData({ ...schedule_data,
      useDisableDates: disableDates
    });
  };

  const addTimeToSelectedDate = (timeToAdd) => {
    // Clone the selected date to avoid modifying the original date object
    const newDate = new Date(schedule_data?.selected_date);

    // Extract hours and minutes from the timeToAdd string
    const [hours, minutes] = timeToAdd.split(':');

    // Add hours and minutes to the date
    newDate.setHours(newDate.getHours() + parseInt(hours, 10));
    newDate.setMinutes(newDate.getMinutes() + parseInt(minutes, 10));

    handleScheduleData({ ...schedule_data,
      selected_time_slot: timeToAdd,
      utcSlotStartDate: moment(newDate).format(),
      utcSlotEndDate: moment(newDate).add(slot_duration, 'minutes').format() });
  };

  const handleSelectSlot = (value) => {
    addTimeToSelectedDate(value);
  };

  useEffect(() => {
    if (!scheduleList && logData.settings?.scheduleEnable && ([2, 6, 11].includes(logData?.status))) {
      dispatch(fetchSchedules());
    }
    if (actionScheduleFetch.success && scheduleList && actionPortalTrainingsFetch?.success) {
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      if (scheduleList?.calender) {
        handleDateChange(scheduleList.calender, scheduleList?.airport, todayDate, true);
        const parsedBlockedDate = scheduleList?.calender?.settings?.blocked_details?.map(ele => !ele.start_time && ele.block_date) || [];
        setBlockedDate(parsedBlockedDate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleList, logData.settings?.scheduleEnable]);

  useEffect(() => {
    if (permitCategory && scheduleList?.calender && slot_duration) {
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
        handleDateChange(scheduleList.calender, scheduleList?.airport, todayDate, true);
        const parsedBlockedDate = scheduleList?.calender?.settings?.blocked_details?.map(ele => !ele.start_time && ele.block_date) || [];
        setBlockedDate(parsedBlockedDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permitCategory, scheduleList, slot_duration]);

  useEffect(() => {
    if (actionScheduleSlotsFetch.success) {
      let finalSlots = [...schedule_data.available_time_slots];
      const verifyTests = verifyNumberOfTests();
      if (verifyTests) {
        scheduleSlots.forEach((eachVal) => {
          const slotTime = moment(eachVal.start_ts).format('HH:mm');
          finalSlots = finalSlots.filter(slot => slotTime !== slot);
        });
      } else {
        finalSlots = [];
      }
      setLoadingStatus(false);
      handleScheduleData({ ...schedule_data, available_time_slots: finalSlots });
      dispatch(clearScheduleSlotsAction());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionScheduleSlotsFetch, scheduleSlots, slot_duration]);

  useEffect(() => {
    if (actionScheduled.success) {
      setLoadingStatus(false);
      dispatch(clearState());
      push(backRoute);
    }
    if (actionRescheduled?.success) {
      setLoadingStatus(false);
      dispatch(clearState());
      push(backRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionScheduled, actionRescheduled]);

  useEffect(() => {
    if (avpDetailsPage) {
      if (docModal === true) {
        setUploadDocuments(prev => ({
          ...prev,
          attachments: logData?.attachments,
          response: logData?.response
        }));
      } else {
        closeDocModal();
      }
    }
  }, [logData, docModal, avpDetailsPage]);

  useEffect(() => {
    if (avpDetailsPage) {
      if (Object.keys(logData?.response || {}).length > 0) {
        let customFields = logData?.schema?.schema?.fields?.filter(e => e.type === 'attachments');
        let custom_errors = {};
        customFields.forEach((field) => {
          custom_errors = { ...custom_errors, [field.id]: !(logData?.response?.[field.id]) };
        });
        setUploadDocuments(prev => ({ ...prev, response: logData.response, custom_errors }));
      }
    }
  }, [logData, avpDetailsPage]);

  useEffect(() => {
    if (avpDetailsPage) {
      Object.keys(uploadDocuments.custom_errors).forEach((key) => {
        setUploadDocuments(prev => ({
          ...prev,
          custom_errors: {
            ...prev.custom_errors,
            [key]: !uploadDocuments?.response?.[key]?.length
          }
        }));
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadDocuments.response]);

  useEffect(() => {
    if (uploadAvpDocumentsAction?.loading === false && uploadAvpDocumentsAction?.success === true) {
      setLoadingStatus(false);
      closeDocModal();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadAvpDocumentsAction, dispatch, logId]);

  const getRejectedAttachmentIds = () => {
    const verifiedDocs = logData?.work_flow?.verified_documents || {};
    return Object.entries(verifiedDocs)
      .filter(([, value]) => !value?.document_verified)
      .reduce((ids, [key, value]) => ids.concat([
          key,
          value?.id,
          value?.attachment_id,
          ...(Array.isArray(value?.attachment_ids) ? value.attachment_ids : [])
        ]), [])
      .filter(Boolean)
      .map(id => `${id}`);
  };

  const getAttachmentId = attachment => attachment?.attachment_id || attachment?.id || attachment;
  const getAttachmentRemovalId = attachment => attachment?.id || attachment?.attachment_id || attachment;
  const uniqueIds = ids => [...new Set((ids || []).filter(Boolean))];

  const buildUpdateDocumentsState = (removeRejectedDocuments = false) => {
    const attachmentFields = logData?.schema?.schema?.fields?.filter(e => e.type === 'attachments') || [];
    const nextUpdateDocuments = {
      openDocumentModal: false,
      removed_attachements: [],
      photo: [],
      photo_required: false,
      response: {},
      custom_errors: {},
      document_errors: {},
      req_attachments_details: logData?.req_attachments_details || {},
      req_attachments: {}
    };

    if (!(adpDetails || avpDetailsPage)) {
      return nextUpdateDocuments;
    }

    const rejectedIds = new Set(getRejectedAttachmentIds());
    const shouldRemoveRejected = removeRejectedDocuments && rejectedIds.size > 0;
    let removedAttachments = [];

    const isRejectedAttachment = attachment => rejectedIds.has(`${getAttachmentId(attachment)}`);
    const collectRemovedAttachments = (attachments) => {
      if (!shouldRemoveRejected) return;
      removedAttachments = [
        ...removedAttachments,
        ...(attachments || [])
          .filter(isRejectedAttachment)
          .map(getAttachmentRemovalId)
      ];
    };

    if (Object.keys(logData?.req_attachments || {}).length > 0) {
      Object.keys(logData?.req_attachments || {}).forEach((key) => {
        const attachmentAnswer = logData.attachments
          ?.filter(attach => logData?.req_attachments[key]
            ?.includes(attach.attachment_id)) || [];
        const hasRejectedAttachment = attachmentAnswer.some(isRejectedAttachment);

        nextUpdateDocuments.req_attachments[key] = shouldRemoveRejected && hasRejectedAttachment
          ? []
          : attachmentAnswer;
        if (!shouldRemoveRejected || hasRejectedAttachment) {
          nextUpdateDocuments.document_errors[key] = false;
        }
        collectRemovedAttachments(attachmentAnswer);
      });
    }
    if (adpDetails && Array.isArray(logData?.photo) && logData.photo.length > 0) {
      const hasRejectedPhoto = logData.photo.some(isRejectedAttachment);
      nextUpdateDocuments.photo = shouldRemoveRejected && hasRejectedPhoto
        ? logData.photo.filter(attachment => !isRejectedAttachment(attachment))
        : logData.photo;
      nextUpdateDocuments.photo_required = shouldRemoveRejected && hasRejectedPhoto;
      collectRemovedAttachments(logData.photo);
    }
    if (Object.keys(logData?.response || {}).length > 0) {
      Object.keys(logData.response).forEach((fieldId) => {
        if (!attachmentFields.some(field => `${field.id}` === `${fieldId}`)) {
          nextUpdateDocuments.response[fieldId] = logData.response[fieldId];
        }
      });

      attachmentFields.forEach((field) => {
        const attachmentAnswer = logData?.response?.[field.id] || [];
        const hasRejectedAttachment = attachmentAnswer.some(isRejectedAttachment);

        if (attachmentAnswer.length > 0 && !(shouldRemoveRejected && hasRejectedAttachment)) {
          nextUpdateDocuments.response[field.id] = attachmentAnswer;
        }
        if (!shouldRemoveRejected || hasRejectedAttachment) {
          nextUpdateDocuments.custom_errors[field.id] = false;
        }
        collectRemovedAttachments(attachmentAnswer);
      });
    }

    nextUpdateDocuments.removed_attachements = uniqueIds(removedAttachments);
    return nextUpdateDocuments;
  };

  useEffect(() => {
    setUpdateDocuments(buildUpdateDocumentsState(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logData]);

  useEffect(() => {
    Object.keys(updateDocuments.custom_errors).forEach((key) => {
      setUpdateDocuments(prev => ({
        ...prev,
        custom_errors: {
          ...prev.custom_errors,
          [key]: !updateDocuments?.response?.[key]?.length
        }
      }));
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateDocuments?.response]);

  useEffect(() => {
    if (updateRequiredDocumentsAction?.loading === false && updateRequiredDocumentsAction?.success) {
      setLoadingStatus(false);
      setUpdateDocuments({ ...updateDocuments, openDocumentModal: false, removed_attachements: [], req_attachments: {} });
      if (adpDetails) handleGetLatestADPDetails();
      if (avpDetailsPage) getLatestAvpDetails();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRequiredDocumentsAction]);
  const handleSetAttachments = (section, attachment, key) => {
    if (section === 'req_attachments') {
      setUpdateDocuments(prev => ({
        ...prev,
          [section]: {
          ...prev[section],
          [key]: attachment
        }
      }));
    } else if (section === 'removed_attachements') {
      setUpdateDocuments(prev => ({
        ...prev,
          [section]: uniqueIds([
            ...prev[section],
            attachment
          ])
      }));
    } else if (section === 'req_attachments_dates') {
      setUpdateDocuments(prevState => ({
        ...prevState,
          req_attachments_details: {
            ...prevState.req_attachments_details,
            [section]: {
              ...prevState.req_attachments_details?.[section],
              [key]: attachment
            }
          }
      }));
    } else if (section === 'photo') {
      setUpdateDocuments(prev => ({
        ...prev,
        [section]: attachment
      }));
    } else if (section === 'response') {
      setUpdateDocuments(prev => ({
        ...prev,
          [section]: {
          ...prev[section],
          [key]: attachment
          }
      }));
    }
  };
  const handleUploadFiles = async (files = [], entity) => {
    if (!files.length) return { attachmentIds: [], newAttachmentIds: [] };

    const newAttachments = files.filter(file => file && typeof file !== 'string' && !file.id && !file.attachment_id);
    const oldAttachmentIds = files
      .filter(file => typeof file === 'string' || file?.attachment_id)
      .map(file => (typeof file === 'string' ? file : file.attachment_id));

    let fileIds = newAttachments.length > 0 ? await GetFileName.getPermitUploadFileName(newAttachments.length) : null;
    let newAttachmentIds = [];

    if (fileIds) {
      await S3Uploads.uploadFiles(newAttachments, fileIds.filename, entity);
      newAttachmentIds = fileIds.filename.map(attachName => attachName.toString());
    }

    return { attachmentIds: [...oldAttachmentIds, ...newAttachmentIds], newAttachmentIds };
  };
  const updateCustomAttachmentsState = async (entity) => {
    const updatedCustomAttachments = {};
    let newUploadedAttachmentIds = [];

    const uploadPromises = Object.entries(updateDocuments?.response || {})
      .filter(([key]) => logData?.schema?.schema?.fields.some(e => (e.type === 'attachments' || e.type === 'signature') && e.id === key))
      .map(async ([key, attachments]) => {
        const { attachmentIds, newAttachmentIds } = await handleUploadFiles(attachments, entity);
        updatedCustomAttachments[key] = attachmentIds;
        newUploadedAttachmentIds = [...newUploadedAttachmentIds, ...newAttachmentIds];
      });

    await Promise.all(uploadPromises);

    return { updatedCustomAttachments };
  };

  const uploadAttachments = async (documentsInfo) => {
    const updatedReqAttachments = {};
    let newUploadedAttachmentIds = [];

    const uploadPromises = Object.entries(documentsInfo?.req_attachments || {}).map(async ([reqAttch, attachments]) => {
      const { attachmentIds, newAttachmentIds } = await handleUploadFiles(attachments, adpDetails ? 'driver_permit' : 'vehicle_permit');
      updatedReqAttachments[reqAttch] = attachmentIds;
      newUploadedAttachmentIds = [...newUploadedAttachmentIds, ...newAttachmentIds];
    });

    await Promise.all(uploadPromises);

    return { updatedReqAttachments, newUploadedAttachmentIds };
  };
  const handleSaveDocuments = async () => {
    const requiredReqAttachmentKeys = Object.keys(updateDocuments?.document_errors || {});
    const requiredCustomFieldKeys = Object.keys(updateDocuments?.custom_errors || {});
    const reqAttachmentErrors = requiredReqAttachmentKeys.reduce((acc, key) => ({
      ...acc,
      [key]: !(updateDocuments?.req_attachments?.[key] || []).length
    }), {});
    const customAttachmentErrors = requiredCustomFieldKeys.reduce((acc, key) => ({
      ...acc,
      [key]: !updateDocumentsDate ? !(updateDocuments?.response?.[key] || []).length : false
    }), {});
    const noErrors = requiredReqAttachmentKeys.every(key => !reqAttachmentErrors[key]);

    setUpdateDocuments(prev => ({
      ...prev,
      document_errors: {
        ...prev.document_errors,
        ...reqAttachmentErrors
      },
      custom_errors: {
        ...prev.custom_errors,
        ...customAttachmentErrors
      }
    }));

    if (noErrors) {
      const { isCustomAttachmentValid, isPhotoValid } = validateAttachments(
        customAttachmentErrors,
        updateDocuments.photo,
        updateDocuments.photo_required
      );
      if (!isCustomAttachmentValid) {
        setUpdateDocuments(prev => ({
          ...prev,
          showDocumentError: true
        }));
        return;
      }
      if (!isPhotoValid) {
        setUpdateDocuments(prev => ({
          ...prev,
          showDocumentError: true
        }));
        return;
      }

      setLoadingStatus(true);

      const [
        { updatedReqAttachments, newUploadedAttachmentIds },
        { updatedCustomAttachments },
        { attachmentIds: photoIds }
      ] = await Promise.all([
        uploadAttachments(updateDocuments),
        updateCustomAttachmentsState(adpDetails ? 'driver_permit' : 'vehicle_permit'),
        handleUploadFiles(updateDocuments.photo, 'driver_permit')
      ]);

      const payload = {
        req_attachments: updatedReqAttachments,
        req_attachments_details: Object.keys(updateDocuments.req_attachments_details || {}).length > 0
          ? {
              req_attachments_dates: {
                ...(logData?.req_attachments_details?.req_attachments_dates),
                ...(updateDocuments.req_attachments_details?.req_attachments_dates)
              }
            }
          : logData?.req_attachments_details,
        removed_attachments: updateDocuments.removed_attachements,
        new_attachments: [...newUploadedAttachmentIds, ...photoIds],
        response: { ...updateDocuments.response, ...updatedCustomAttachments }
      };
      if (adpDetails) payload.photo = photoIds;
      dispatch(updateRequiredDocuments(logId, payload, adpDetails ? 'adp' : 'avp'));
      setUpdateDocumentsModal(false);
      handleDocDateModal(false);
    } else {
      setUpdateDocuments(prev => ({
        ...prev,
        showDocumentError: true
      }));
    }
  };

  const validateAttachments = (customAttachmentErrors, photo, isPhotoRequired = false) => {
    const isCustomAttachmentValid = Object.values(customAttachmentErrors).every(attachment => attachment === false);
    const isPhotoValid = isPhotoRequired ? photo?.length > 0 : true;
    return { isCustomAttachmentValid, isPhotoValid };
  };

const closeDocModal = () => {
  setUploadDocuments(prev => ({
    ...prev,
    attachments: [],
    response: {},
    removed_attachments: []
  }));
  setDocModal(false);
};

const handleUploadAttachments = async (attachments, entity) => {
  const attachmentIds = [];
  const newAttachmentIds = [];
  const newAttachments = [];
  const oldAttachments = [];
  attachments.forEach((e) => {
    if (!e.id) {
      newAttachments.push(e);
    } else if (e.id && e.file_name) {
      oldAttachments.push(e.attachment_id);
    }
  });
  let fileIds = '';
  if (newAttachments.length > 0) {
    fileIds = await GetFileName.getUploadFileName(newAttachments?.length);
  }
  if (fileIds) {
    await S3Uploads.uploadFiles(
      newAttachments,
      fileIds.filename,
      entity || 'avp'
    ).then(() => {
      fileIds.filename.forEach((attachName) => {
        attachmentIds.push(attachName.toString());
        newAttachmentIds.push(attachName.toString());
      });
    });
  }
  if (oldAttachments.length > 0) {
    attachmentIds.push(...oldAttachments);
  }
  return { newAttachmentIds };
};

const handleSaveUploadDocuments = async () => {
  const noErrors = uploadDocuments
    && (uploadDocuments.attachments)?.length > 0;
  if (noErrors) {
    const { isCustomAttachmentValid } = validateAttachments(uploadDocuments.custom_errors);

    if (!isCustomAttachmentValid) {
      setUploadDocuments(prev => ({
        ...prev,
        showDocumentError: true
      }));
      return;
    }
    setLoadingStatus(true);

    const [
      { newAttachmentIds },
      { updatedCustomAttachments }
    ] = await Promise.all([
      handleUploadAttachments(uploadDocuments.attachments, 'avp'),
      updateCustomAttachmentsState('avp')
    ]);

    const payload = {
      removed_attachments: uploadDocuments.removed_attachments,
      new_attachments: [...newAttachmentIds],
      response: { ...uploadDocuments.response, ...updatedCustomAttachments }
    };
    dispatch(uploadAvpAttachments(logId, payload));
  } else {
    setUploadDocuments(prev => ({
      ...prev,
      showDocumentError: true
    }));
  }
};

const handleUploadDocuments = (section, attachment, key) => {
  if (section === 'attachments') {
    setUploadDocuments(prev => ({
      ...prev,
        [section]: attachment
      }
    ));
  } else if (section === 'removed_attachments') {
    setUploadDocuments(prev => ({
      ...prev,
        [section]: [
          ...prev[section],
          attachment
        ]
    }));
  } else if (section === 'response') {
    setUploadDocuments(prev => ({
      ...prev,
        [section]: {
        ...prev[section],
        [key]: attachment
        }
    }));
  }
};

const handleGetAttachmentNamesAndValues = (attachmentList = []) => {
  let newCustomAttachmentList = [];
  let newAttachmentList = attachmentList;
  const reqAttachmentList = Object.keys(logData?.req_attachments || {});
  const customFieldAttachments = logData?.schema?.schema?.fields?.filter(field => field.type === 'attachments') || [];
  const customFieldDetails = customFieldAttachments
    .filter(field => Array.isArray(logData?.response?.[field.id]) && logData.response[field.id].length > 0);

  if (reqAttachmentList?.length > 0) {
  // extract required attachment name from applicationDetails?.req_attachments
    newAttachmentList = attachmentList.map((attachId) => {
      let newAttachName = attachId.file_name;
      reqAttachmentList.forEach((eachVal) => {
        let attachmentVal = [...logData?.req_attachments[eachVal]];
        if (attachmentVal.includes(attachId.attachment_id)) {
          newAttachName = eachVal.split('_')?.[0];
        }
      });
      if (logData?.photo?.some(profilePic => profilePic.attachment_id === attachId.attachment_id)) {
        newAttachName = 'Profile Picture';
      }
      return ({ ...attachId, attachmentFieldName: newAttachName });
    });
  }
  if (customFieldDetails?.length > 0) {
    newCustomAttachmentList = customFieldDetails
      .filter(field => field.type === 'attachments'
        && Array.isArray(logData?.response?.[field.id])
        && logData.response[field.id].length > 0)
      .flatMap(field => logData.response[field.id].map(attachment => ({
            ...attachment,
            attachmentFieldName: field.title // Assigning the field title as attachmentFieldName
          })));
    newAttachmentList = [...newAttachmentList, ...newCustomAttachmentList];
  }
  return newAttachmentList || [];
};

  const handleViewReceipts = (value) => {
    setViewReceipts(value);
  };

  const handleSelectInvoice = (invoice) => {
    setInvoiceLoading(true);
    setSelectedInvoice(invoice);
    setViewReceipts(false);
    // small delay ensures ref updates before print
    setTimeout(() => {
    setInvoiceLoading(false);
      window.printTrigger.click();
    }, 500);
  };

  const renderReceipts = () => (
    <div className={styles.invSubList}>
      {logData?.invoicesByFeeType?.map(inv => (
        <div key={inv.serial_number}>
          <button
            type="button"
            onClick={() => handleSelectInvoice(inv)}
            onKeyDown={() => handleSelectInvoice(inv)}
          >
            {`#${inv.serial_number} - ${renderInfoForType({ type: 'date' }, inv.payment_date)}`}
          </button>
        </div>
      ))}
    </div>
  );

const getTenantPaymentType = () => {
  if (avpDetailsPage) {
    return logData?.meta_data?.avp_payment_type_for_tenant === 'offline';
  }
  return logData?.meta_data?.adp_payment_type_for_tenant === 'offline';
};

const handlePayment = (tokenDetails, payment_value) => {
  if (tokenDetails) {
    const payload = {
      payment_info: {
        id: tokenDetails?.token?.id || null,
        amount: payment_value || 0,
        description: invoiceObject?.description || '',
        fee_type: invoiceObject?.fee_type,
        other_info: {
          ...invoiceObject,
          currency: profile?.portal_airport?.airport_settings?.currency || '$'
        },
        payment_by_tenant: getTenantPaymentType()
      }
    };
    if (avpDetailsPage) {
      dispatch(makeAvpPayment(logData.id, payload));
    } else {
      dispatch(makeAdpPayment(logData.id, payload));
    }
  }
};

 const generateFutureDates = (mandateDays) => {
    // THIS FUNCTION GENEREATES DATES FOR BLOCKING IN SCHEDULING WITHIN THE MENTION mandateDays
    const dates = [];
    const now = new Date();

    for (let numOfDays = 0; numOfDays < mandateDays + 1; numOfDays++) {
      const futureDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + numOfDays,
        0, 0, 0
      ));
      const parsedDate = parseISO(futureDate.toISOString().replace(/\.\d{3}Z$/, '.000Z'));
      dates.push(parsedDate);
    }
  return dates;
  };

  const getFeeAmount = () => {
    let fee = {};
    if (logData?.work_flow?.payments?.length > 0) {
      const submissions = logData.work_flow.payments
        .filter(item => item.fee_type === 'on_application_submission');
      const payment = submissions.length > 0
        ? submissions.reduce((max, item) => (item.id > max.id ? item : max))
        : undefined;
      if (payment) {
        fee.amount = payment.amount;
        fee.txn_id = payment.txn_id;
      }
    }
    return fee;
  };

  const renderRefundedDetails = () => {
    const currency = profile?.portal_airport?.airport_settings?.currency || '$';
    const refundData = cancellationResponse?.payment_response?.payment_instance;

    const RefundRow = ({ labelId, defaultLabel, value }) => (
      <div className={styles.refundRow}>
        <span>
          <FormattedMessage id={labelId} defaultMessage={defaultLabel} />
        </span>
        <span>{value}</span>
      </div>
    );
    const amountWithCurrency = amount => `${currency}${(Number(amount) || 0).toFixed(2)}`;

    return (
      <>
        <div className={styles.modalTitle}>
          <FormattedMessage tagName="h4"
            id="module.adp.refund_details"
            defaultMessage="Refund Details"
          />
        </div>
        <div className={styles.refund}>
          <div className={styles.refundDetails}>
            <p>
              <FormattedMessage
                id="module.adp.refund_success"
                defaultMessage="Your refund has been initiated and will be completed within 3–5 business days."
              />
            </p>
            <RefundRow
              labelId="module.adp.transaction_id"
              defaultLabel="Transaction ID:"
              value={refundData?.txn_id || '-'}
            />
            <RefundRow
              labelId="module.adp.paid_amount" defaultLabel="Application Fee (Paid):"
              value={amountWithCurrency(getFeeAmount()?.amount)}
            />
            <RefundRow
              labelId="module.adp.cancelled_amount" defaultLabel="Cancellation Fee:"
              value={amountWithCurrency(cancellationFee?.grandTotal)}
            />
            <RefundRow
              labelId="module.adp.refund_amount" defaultLabel="Refund Amount:"
              value={amountWithCurrency(refundData?.amount)}
            />
          </div>
        </div>
        <div className={styles.modalBtnContainer}>
          <Button
            action="tertiary" onClick={() => setRefundPopup(false)}
            translationID="module.adp.close" defaultText="Close"
          />
        </div>
      </>
    );
  };

  const renderCancellationMessage = () => {
    const currency = profile?.portal_airport?.airport_settings?.currency || '$';
    const feeAmount = Number(getFeeAmount()?.amount) || 0;
    const cancellationAmount = Number(cancellationFee?.grandTotal) || 0;

    const checkAmount = (adpDetails && settings?.enablePermitFees && paymentByTenant && feeAmount > 0);
    const hasRefund = (checkAmount && cancellationAmount > 0 && feeAmount > cancellationAmount);
    const shouldShowMessage = (checkAmount && (feeAmount > cancellationAmount || cancellationAmount === 0));

    if (!shouldShowMessage) return null;

    const refundAmount = (feeAmount - cancellationAmount).toFixed(2);

    const message = cancellationAmount > 0
        ? `Please note that a cancellation fee of ${currency}${cancellationAmount.toFixed(2)}
          will be retained, and a refund of ${currency}${refundAmount} will be credited to your credit card.`
        : `Please note that a refund of ${currency}${refundAmount} will be credited to your credit card.`;

    return (
      <p className={styles.cancellationMessage}>
        {hasRefund && (
          <Checkbox
            id="cancellation.refund.message"
            label="" checked={checkRefund}
            onChange={() => setCheckRefund(prev => !prev)}
          />
        )}
        <FormattedMessage
          id="cancellation.refund.message"
          defaultMessage={message}
        />
      </p>
    );
  };

  const handleCloseReprint = () => {
    setModal(false);
    setActiveId({ reprint_info: {}, selectedId: null });
  };

  const handleSelectChange = (selectedOption) => {
    setActiveId({
      reprint_info: selectedOption,
      selectedId: selectedOption?.id
    });
  };

  const renderReprintList = () => {
    const formattedOptions = rePrintList.map(item => ({
      id: item.id,
      label: item.name,
      name: item.name,
      value: item.id
    }));
    return (
    <div className={styles.invSubList}>
      <FormattedMessage
        id="module.adp.select_reprint_option"
        defaultMessage="Choose a reason for badge reprint request"
        tagName="h6"
      />
      {rePrintList?.length > 0 && (
        <Select
          options={formattedOptions}
          onChange={handleSelectChange}
          value={formattedOptions.find(option => option.value === activeId.selectedId)}
          getOptionLabel={e => (
            <div>
              {e.label}
            </div>
          )}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 1001 })
          }}
          menuPortalTarget={document.body}
        />
      )}
    </div>);
  };

  const getAttachmentsExpiringWithinDays = (
    dates = {},
    attachments = {}
  ) => {
    const data = Object.entries(dates).map(([dateKey, dateValue]) => {
      const baseKey = dateKey.replace('_date', '');
      const attachmentKey = `${baseKey}_attachments`;
      return {
        name: baseKey,
        date: dateValue,
        attachment_id: attachments[attachmentKey] || []
      };
    });

    return {
      data
    };
  };

  const checkAttachmentsExpiring = getAttachmentsExpiringWithinDays(
    logData?.req_attachments_details?.req_attachments_dates, logData?.req_attachments
  );

  const handleDocDateModal = (val) => {
    setUpdateDocumentsDate(val);
    if (val) {
      setUpdateDocuments(buildUpdateDocumentsState(false));
      const expiringData = checkAttachmentsExpiring?.data;
      setExpiringAttachments(expiringData || []);
    } else {
      setExpiringAttachments([]);
    }
  };

const handleSkip = (value, paymentVal = 0) => {
  const payValue = paymentByTenant ? paymentVal : 0;
  const payload = {
    skip_payment: true,
    payment_info: {
      id: null,
      amount: payValue,
      description: invoiceObject?.description || '',
      fee_type: invoiceObject?.fee_type,
      other_info: {
        ...invoiceObject,
        currency: profile?.portal_airport?.airport_settings?.currency || '$'
      }
    }
  };
  if (!payValue) {
    if (avpDetailsPage) {
      dispatch(makeAvpPayment(logData.id, payload));
    } else {
      dispatch(makeAdpPayment(logData.id, payload));
    }
  } else {
    setPaymentModal(value);
  }
};

  const handleOfflinePayment = () => {
    const payload = {
      payment_info: {
        id: null,
        amount: invoiceObject?.grandTotal || 0,
        description: invoiceObject?.description || '',
        fee_type: invoiceObject?.fee_type,
        other_info: {
          ...invoiceObject,
          currency: profile?.portal_airport?.airport_settings?.currency || '$'
        },
        payment_by_tenant: getTenantPaymentType()
      }
    };
    if (avpDetailsPage) {
      dispatch(makeAvpPayment(logData.id, payload));
    } else {
      dispatch(makeAdpPayment(logData.id, payload));
    }
  };

  const handleInitiateTnsPayments = () => {
    handlePayment(true, invoiceObject?.grandTotal || 0);
  };

  const handlePaymentMethods = () => {
    if (isTnsPaymentTrackingEnable) {
      handleInitiateTnsPayments();
    } else {
      setPaymentModal(!paymentModal);
      setActionsShow(false);
    }
  };

  const blockDate = blockedDate.map(ele => new Date(moment(ele)));
  const disableMandateDates = +logData?.settings?.noOfDaysToMandate ? generateFutureDates(+logData?.settings?.noOfDaysToMandate) : [];
  const useDates =[...useDisableDates, ...blockDate, ...disableMandateDates];
  const selectedDate = moment(schedule_data?.selected_date).format('YYYY-MM-DD');
  const hasToday = useDates.some(dateString => moment(dateString).format('YYYY-MM-DD') === selectedDate);
  const hasReceipts = (adpDetails || avpDetailsPage)
    && logData?.settings?.custom_invoice_template
    && logData?.work_flow?.payments?.length > 0;
  const rejectedList = getRejectedAttachmentIds();

  const handleOpenUpdateDocumentsModal = () => {
    setUpdateDocuments(buildUpdateDocumentsState(true));
    setUpdateDocumentsModal(true);
    setActionsShow(false);
  };

  const handleCloseUpdateDocumentsModal = () => {
    setUpdateDocumentsModal(false);
    setUpdateDocuments(buildUpdateDocumentsState(false));
  };

  let paymentModule = '';
  if (adpDetails) {
    paymentModule = 'driver_permit';
  } else if (avpDetailsPage) {
    paymentModule = 'vehicle_permit';
  }

  return (
    <>
      <Loading loadingStatus={Object.entries(logData).length===0 || loadingStatus || suspendAction?.loading
         || avpPaymentStatus?.loading || paymentActionStatus?.loading
         || revokeAction?.loading || adpAvpCancelAplicationAction?.loading || adpRePrintStatus?.loading
         || renewalFlow?.loader || adpInitiationStatus?.loading || invoiceLoading}
      />
      <SectionHeader
        icon={PERMITMODULE}
        translationID="shortcuts.detail"
        defaultTitle={panelname}
      >
        {/* only call get calender detail api when it is enable getting 500 when it load remove it */}
        {actionsBtn && (Number(logData?.status) === 3
        || canclletionStatus?.includes(Number(logData?.status))
        || (Number(logData?.status) === 5 && (!logData.offline_training || profile?.permissions?.airfield_worker_driver_permit?.Renew))
        || Number(logData?.status) === 4
        || Number(logData?.status) === 8
        || Number(logData?.status) === 10
        || Number(logData?.status) === 18
        || (Number(logData?.status) === 11
        && (logData.settings?.scheduleEnable
        && (logData.settings?.calendar_visibility === 'company' || logData.settings?.calendar_visibility === 'both')))
        || (!actionPending && !logData.offline_training
          && (Number(logData?.status) === 2)))
          && <div className={styles.actionBtn} style={{ paddingRight: '26px' }}>
              <Clickable
                className={styles.actionsBtn}
                onClick={() => setActionsShow(!actionsShow)}
              >
                <FormattedMessage
                  id="workorders.detail.actionBtn"
                  defaultMessage="Actions"
                />
              </Clickable>
              {actionsShow && (
              <ul className={`${styles.actionpopup} ${actionsShow ? styles.open : ''}  ${styles.actionsHeight}`}
                style={{ width: logData?.status === 4 ?'115px' : '184PX' }}
              >
                {((logData?.status === 15 || logData?.status === 18) && rejectedList?.length > 0) && ((adpDetails
                && (profile?.permissions?.driver_permit?.includes('change_driverpermit') || profile?.permissions?.airfield_worker_driver_permit?.View)
                ) || (avpDetailsPage && profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit'))) && (
                    <li className={styles.item}>
                      <Clickable
                        onClick={() => handleOpenUpdateDocumentsModal()}
                      >
                        <FormattedMessage
                          id="module.adp.update_documents"
                          defaultMessage="Update Documents"
                        />
                      </Clickable>
                    </li>
                  )
                }
                {logData?.status === 2
                  && (avpDetailsPage
                  && logData?.vehicle_info?.imported
                  && !logData?.work_flow?.doc_verified_on?.length
                  && !logData?.attachments?.length
                  && profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit'))
                  && (
                    <li className={styles.item}>
                      <Clickable
                        onClick={() => setDocModal(true)}
                      >
                        <FormattedMessage
                          id="module.avp.upload_documents"
                          defaultMessage="Upload Documents"
                        />
                      </Clickable>
                    </li>
                  )
                }
                {(logData?.status === 5 || logData?.status === 3) && ((avpDetailsPage && !logData?.is_renewed
                && (profile?.permissions?.vehicle_permit?.includes('add_vehiclepermit')
                || profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit')))
                || (adpDetails && !logData?.is_renewed && (profile?.permissions?.driver_permit?.includes('add_driverpermit')
                || profile?.permissions?.driver_permit?.includes('change_driverpermit')) && !myApplication)
                || (myApplication && profile?.permissions?.airfield_worker_driver_permit?.Renew && !logData?.is_renewed)
                )
                    && (
                        <li className={styles.item}>
                          <Clickable
                            onClick={(adpDetails && settings?.initiateWithPortalUsers)
                                ? () => handleRenewalConfirmation(logId)
                                : () => props.history.push({
                              pathname: `${logData.id}/renewal`,
                              state: { isAdminForm: settings?.allow_admin_to_submit_driver_application, myApplication }
                            })}
                          >
                        Renew
                          </Clickable>
                        </li>
                    )
                  }
                { logData.offline_training === false
                && logData?.settings?.allow_admin_to_submit_driver_application === false
                && (logData?.status === 2 || logData.status === 3 || logData.status === 5)
                        && (
                        <li className={styles.item}>
                          <Clickable>
                            <a style={{ color: 'black', textDecorationLine: 'none' }} href={logData.certificate_url} download>
                              <p style={{ fontSize: 'bold', margin: 0 }}> Download Certificate</p>
                            </a>
                          </Clickable>
                        </li>
                        )
                  }
                {logData?.status === 4 && !logData?.reject_payment
                  && ((!myApplication && avpDetailsPage && profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit'))
                  || (!myApplication && adpDetails && profile?.permissions?.driver_permit?.includes('change_driverpermit'))
                  || (myApplication && profile?.permissions?.airfield_worker_driver_permit?.Edit)) && (
                    <li className={styles.item}>
                      <Clickable
                        onClick={() => push(`${logData.id}/reapply`)}
                      >
                          Re Open
                      </Clickable>
                    </li>
                  )
                }
                {avpDetailsPage && ([3, 8].includes(logData.status))
                  && settings?.disable_avp_attachment_expiry_actions
                  && (
                  <li className={styles.item}>
                    <Clickable
                      onClick={() => { handleDocDateModal(true); setActionsShow(false); }}
                    >
                      <FormattedMessage
                        id="module.adp.update_expiry_dates"
                        defaultMessage="Update Expiry Dates"
                      />
                    </Clickable>
                  </li>
                )}
                {logData?.status === 3
                  && ((avpDetailsPage || adpDetails) && !checkReprintRequest())
                      && (
                      <>
                        <li className={styles.item}>
                          <Clickable
                            onClick={() => {
                              setModal(!rePrintModal);
                              setModal(!rePrintModal);
                            }}
                          >
                            Badge Reprint
                          </Clickable>
                        </li>
                        {((avpDetailsPage && profile?.permissions?.vehicle_permit?.includes('can_suspend_vehiclepermit'))
                        || (adpDetails && profile?.permissions?.driver_permit?.includes('can_suspend_driverpermit')))
                         && (
                            <li className={styles.item}>
                              <Clickable
                                onClick={() => {
                                  handleActions('suspend', 'openSuspendModal', !actionDetails?.suspend?.openSuspendModal);
                                  setActionsShow(!actionsShow);
                                }}
                              >
                                <FormattedMessage
                                  id="adp.details.suspend"
                                  defaultMessage="Suspend"
                                />
                              </Clickable>
                            </li>
                        )}
                      </>
                      )
                   }
                  {(logData?.status === 3 || logData?.status === 5)
                  && ((avpDetailsPage && profile?.permissions?.vehicle_permit?.includes('can_revoke_vehiclepermit'))
                  || (adpDetails && profile?.permissions?.driver_permit?.includes('can_revoke_driverpermit'))) && (
                    <li className={styles.item}>
                      <Clickable
                        onClick={() => {
                          handleActions('revoke', 'operRevokeModal', !actionDetails?.revoke?.operRevokeModal);
                        }}
                      >
                        <FormattedMessage
                          id="adp.details.revoke"
                          defaultMessage="Revoke"
                        />
                      </Clickable>
                    </li>
                  )}
                  {logData?.status === 11 && logData?.settings?.scheduleEnable && !(logData?.work_flow?.booking?.status === 'cancelled')
                  && (
                      <li className={styles.item}>
                        <Clickable
                          onClick={() => {
                            setScheduleModal(!scheduleModal);
                          }}
                        >
                            Schedule Appointment
                        </Clickable>
                      </li>
                    )
                  }
                  {(adpDetails || avpDetailsPage) && paymentByTenant && !hasOfflinePayment && (
                    (logData?.status === 10)
                    || (logData?.payment_stage === 'on_reprint_application' && checkReprintRequest())
                    || (logData?.status === 4 && logData?.reject_payment)
                  ) && (
                    <li className={styles.item}>
                      <Clickable
                        onClick={() => { handlePaymentMethods(); }}
                      >
                        <FormattedMessage
                          id="adp.details.payment"
                          defaultMessage="Make Payment"
                        />
                      </Clickable>
                    </li>
                  )}
                {(settings?.scheduleEnable && logData?.settings?.allowApplicantReschedule
                  && (logData?.work_flow?.skill_test_status === 'fail'
                    || (myApplication
                        && handleMyApplicationSchedule()
                        && (logData?.status === 2 || logData?.status === 6))
                    || logData?.work_flow?.booking?.status === 'cancelled')
                ) && (
                  <li className={styles.item}>
                    <Clickable
                      onClick={() => {
                        setScheduleModal(!scheduleModal);
                        if (logData?.work_flow?.booking?.status === 'cancelled') {
                          setReschedule(!reSchedule);
                        }
                      }}
                    >
                      <FormattedMessage
                        className={styles.label1}
                        id="myApplications.reschedule"
                        defaultMessage="Re-Schedule Appointment"
                      />
                    </Clickable>
                  </li>
                )}
              {
                    (
                      canclletionStatus?.includes(Number(logData?.status))
                      || (
                        logData?.status === 3
                        && adpDetails
                        && profile?.permissions?.driver_permit?.includes('change_driverpermit')
                      )
                      || (
                        logData?.status === 3
                        && avpDetailsPage
                        && profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit')
                      )
                    ) && (
                      <li className={styles.item}>
                        <Clickable
                          onClick={() => {
                            handleOpenCancelModal();
                          }}
                        >
                          <FormattedMessage
                            className={styles.label1}
                            id="inspections.step.print1"
                            defaultMessage="Cancel This Permit"
                          />
                        </Clickable>
                      </li>
                    )
                 }
              </ul>
              )}
             </div>
        }
      </SectionHeader>
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute={backRoute}
      />
      {(application_Status === 8 || application_Status === 9 || application_Status === 7)
      && (
        <div className={styles.statusContainer}>
            {application_Status === 8
            &&(
              <p style={{ marginBottom: '0px' }}>
                {logData.suspended_until
                  ? `This Permit is temporarily  suspended until ${renderInfoForType({ type: 'date' },
                    logData.suspended_until, null, null)}`
                  : 'This permit is suspended indefinitely'}
              </p>
            )}
            {application_Status === 9
              && <p style={{ marginBottom: '0px' }}>This permit is permanently revoked</p>
            }
            {application_Status === 7
              && <p style={{ marginBottom: '0px' }}>This Permit has been cancelled</p>
            }
        </div>)
      }
      {(adpDetails || avpDetailsPage) && application_Status === 3 && checkReprintRequest() && logData?.payment_stage === 'on_reprint_application' && (
        <div className={styles.statusContainer}>
          <p style={{ color: 'red' }}>
            <FormattedMessage
              id="module.adp.pending_reprint_payment"
              defaultMessage="Payment pending for reprint request"
            />
          </p>
        </div>
      )}
      {(application_Status !== 8 && application_Status !== 9 && application_Status !== 7)
      && <DetailsStatus current_stage={getCurrentStage()} />}
      <div className={styles.container} style={{ marginTop: '0%' }}>
        <Panel
          title="module.detail"
          defaultTitle="Application Details"
          adpHistory={adpHistory}
          adpComments={isRejected || application_Status === 4 ? adpComments : false}
          handelHistory={props.handelHistory}
          handleComments={handleComments}
          viewReceipts={hasReceipts ? handleViewReceipts : false}
          printRef={printRef} selectedInvoice={selectedInvoice}
          applicationDetails={logData} profile={profile}
        >
          <>
            <div className={styles.requestInfo} style={{ width: '90%' }}>
              {order?.length > 0 && (
                <div className={styles.infoTable}>
                  {logData && getRow(firstHeaders)}
                </div>
              )}
            </div>
            <div className={permitStyle.permitDetails}>
              {reOrder.map(orderId => (
                <>
                  {defaultIDs.includes(orderId) ? (
                    <PermitFieldDetails
                      data={{ ...logData, ...logData?.response }}
                      schema={{ schema: { fields: [...(logData?.schema?.default_fields?.default_field || [])] } }}
                      fields={logData?.schema?.default_fields?.default_field
                        ? [...logData.schema.default_fields.default_field]
                        : []}
                      order={orderId}
                    />
                  ) : (
                    <PermitFieldDetails
                      data={{ ...logData, ...logData?.response }}
                      schema={logData?.schema}
                      fields={logData?.schema?.schema?.fields
                        ? [...logData.schema.schema.fields.filter(e => e.type !== 'header')]
                        : []}
                      order={orderId}
                    />
                  )}
                </>
              ))}
            </div>
            <div className={styles.requestInfo} style={{ width: '90%' }}>
              {order?.length > 0 && (
                <div className={styles.infoTable}>
                  {logData?.work_flow?.booking && (
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage id="appointment" defaultMessage="Appointment" />
                      </span>
                      <span className={styles.rowContent}>
                        {renderInfoForType(
                          { type: 'datetime' },
                          logData?.work_flow?.booking?.start_ts,
                          null,
                          null
                        )}
                      </span>
                    </div>
                  )}
                  {logData && getRow(lastHeaders)}
                </div>
              )}
            </div>
            <div className={styles.requestInfo} style={{ width: '90%' }}>
              {!logData?.schema?.schema?.ordering && (
                <div className={styles.infoTable}>
                  {logData && getRow(tableHeaders)}
                  {logData && getCustomRow()}
                </div>
              )}
            </div>
            {/* displaying suspension details */}
            {logData?.suspended_details?.training_status
              && (
              <div style={{ width: '90%' }}>
                <Collapsible title="Suspension Details"
                  styleClasses={styles.collapsibleHeader}
                  collapsibleHeight="0"
                >
                  <div className={styles.stepInfo}>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.suspend_by" defaultMessage="Suspended By" />
                      <p>{logData?.suspended_details?.suspended_by}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.suspend_date" defaultMessage="Suspended On" />
                      <p>{renderInfoForType({ type: 'datetime' }, logData?.suspended_details?.created_at, null, null)}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.activated_by" defaultMessage="Activated By" />
                      <p>{logData?.suspended_details?.activated_by}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.reactivate_date" defaultMessage="Activated On" />
                      <p>{renderInfoForType({ type: 'datetime' }, logData?.suspended_details?.closed_at, null, null)}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.retaken.training" defaultMessage="Retaken Training" />
                      <p>{logData?.suspended_details?.no_of_reattempts}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.training.start_date" defaultMessage="Training Start Date" />
                      <p>{renderInfoForType({ type: 'datetime' }, logData?.suspended_details?.training_started_at, null, null)}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.training.end_date" defaultMessage="Training End Date" />
                      <p>{renderInfoForType({ type: 'datetime' }, logData?.suspended_details?.training_completed_at, null, null)}</p>
                    </div>
                    <div className={styles.infoHalf}>
                      <FormattedMessage id="permit.suspend.detail.training.status" defaultMessage="Training Status" />
                      <p>{logData?.suspended_details?.training_status}</p>
                    </div>
                  </div>
                </Collapsible>
              </div>
              )
            }
            {logData?.schema?.renewal_fields?.fields?.length > 0 && (logData?.application_type === 'Renewal' || logData?.type_of_issue === 'Renewal')
              && (<>
                    <div className={styles.requestInfo} style={{ width: '90%' }}>
                      <FormattedMessageWithClass
                        id=" "
                        defaultMessage="Extra Fields During Renewal"
                        className={styles.renewalHeading}
                      />
                    </div>
                    <div className={permitStyle.permitDetails} style={{ borderTop: '1px solid #e6eaee' }}>
                      <PermitFieldDetails
                        data={logData.renewal_response || {}}
                        schema={{ schema: { ...logData.schema.renewal_fields } }}
                        fields={logData.schema.renewal_fields.fields}
                      />
                    </div>
                  </>)
            }
            {logData?.attachments
              && <div style={{ width: '90%' }}>
                  <Collapsible
                    title="Attachments"
                    styleClasses={styles.collapsibleHeader}
                    collapsibleHeight="0"
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}
                    key={logData}>
                      {handleGetAttachmentNamesAndValues(logData?.attachments)?.map(ele => (
                      <Clickable className={`mt-4 ${styles.pdflink} ml-4`}
                        onClick={() => setIsAttachmentsPreview(true)}
                        style={{ color: '#4183c4', cursor: 'pointer' }}
                      >
                        {ele.attachmentFieldName || ele.file_name}
                      </Clickable>
                      ))}
                    </div>
                  </Collapsible>
                 </div>
            }
            {logData?.signature
            &&<div style={{ width: '90%' }}>
                <Collapsible
                  title="Signature"
                  styleClasses={styles.collapsibleHeader}
                  collapsibleHeight="0"
                >
                  <div style={{ padding: '15px', marginLeft: '12px' }}>
                  {logData?.signature?.map(ele => <img src={ele.url} alt="signature" />)}.
                  </div>
                </Collapsible>
              </div>
            }

          </>
        </Panel>
      </div>
      {tnsPaymentUrl && (
        <TnsPaymentModal
          tnsPaymentUrl={tnsPaymentUrl}
          onClosePaymentModal={() => handleTnsPaymentUrl('')}
          tnsPaymentModal={false}
          tnsPaymentMessages={false}
        />
      )}
      {isAttachmentsPreview && (
      <Modal
        showIn={isAttachmentsPreview}
        onClose={() => setIsAttachmentsPreview(false)}
        width="943px"
        minHeight="150px"
        contentStyles={{ padding: '15px 30px 5px 40px' }}
      >
        <FileSlider
          reqAttachmentDetails={logData.req_attachments_details}
          showAttachFieldName
          photos={handleGetAttachmentNamesAndValues([...logData?.attachments, ...logData?.additional_attachments])}
          initialSlide={0}
        />
      </Modal>
      )}
      <Modal
        showIn={updateDocumentsModal}
        onClose={() => handleCloseUpdateDocumentsModal()}
        width="864px" minHeight="150px" closeIcon disableOutsideClick
        title="Update Documents" titleId="module.adp.update_documents"
        btnList={[
          { id: 'training.module.cancel', label: 'Cancel', action: 'tertiary', onClick: () => handleCloseUpdateDocumentsModal() },
          { id: 'module.adp.update_documents', label: 'Update Documents', action: 'secondary', onClick: () => handleSaveDocuments() }
        ]}
      >
        <div className={styles.modalBody}>
          <UpdateRequiredDocuments
            reqAttachmentFields={logData?.schema?.default_fields?.required_attachements|| []}
            updateDocuments={updateDocuments}
            handleCloseDocumentModal={() => setUpdateDocuments({ ...updateDocuments, openDocumentModal: false })}
            handleUpdateDocuments={handleSetAttachments}
            answers={updateDocuments}
            customFields={logData?.schema?.schema?.fields?.filter(e => e.type === 'attachments')}
            logData={logData}
            documentList={rejectedList}
          />
        </div>
      </Modal>

      <Modal
        showIn={docModal} onClose={() => setDocModal(false)}
        width="864px" minHeight="150px" closeIcon disableOutsideClick
        title="Upload Documents" titleId="applications.upload_documents"
        btnList={[
          { id: 'training.module.cancel', label: 'Cancel', action: 'tertiary', onClick: () => setDocModal(false) },
          { id: 'module.adp.update_documents', label: 'Update Documents', action: 'secondary', onClick: () => handleSaveUploadDocuments() }
        ]}
      >
        <div className={styles.modalBody}>
          <UploadAvpDocuments
            handleUploadDocuments={handleUploadDocuments}
            customFields={logData?.schema?.schema?.fields?.filter(e => e.type === 'attachments')}
            uploadDocuments={uploadDocuments}
          />
        </div>
      </Modal>

      <Modal
        showIn={rePrintModal} onClose={() => setModal(false)}
        title={'Confirmation'} closeIcon disableOutsideClick
        width="400px" minHeight="100px"
        btnList={[
          { id: 'filter.cancel', label: 'Cancel', action: 'tertiary', onClick: () => handleCloseReprint() },
          { id: 'filter.reprint',
            label: 'Re Print',
            action: 'secondary',
            onClick: () => handelReprint(logData.id),
            disabled: (adpDetails || avpDetailsPage) && rePrintList?.length > 0 && !activeId.selectedId
          }
        ]}
      >
        <div className={styles.modalBodyContainer}>
          <FormattedMessage
            id="adp.reprint.confirmation.message"
            defaultMessage="Are you sure you want to re-print the badge?"
            tagName="h5"
          />
          {(adpDetails || avpDetailsPage) && rePrintList?.length > 0 && renderReprintList()}
        </div>
      </Modal>
      {(useCalendarData?.id && slot_duration) && (
      <Modal showIn={scheduleModal && !tnsPaymentModal} width="52%" minHeight="27%" onClose={() => setScheduleModal(false)}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #dadce0', padding: '15px' }}>
          <p style={{ margin: 0 }}>Confirmation</p>
          <div style={{ cursor: 'pointer' }} onClick={() => (setScheduleModal(false))}
            onKeyPress={() => (setScheduleModal(false))} role="button" tabIndex={0}>X
          </div>
        </div>
        <div className={scheduleStyle.Container}>
          <div className={scheduleStyle.Container1}>
            <div className={scheduleStyle.Container2} style={{ boxShadow: '0px  0px' }}>
              <div className={scheduleStyle.box}>
                <div className={scheduleStyle.aeroStyle}>
                  <div className={scheduleStyle.box1}>
                    <img className={scheduleStyle.imgstyle} src={airportData?.logo} alt="Aerosimple" />
                  </div>
                  <hr />
                  <div className={scheduleStyle.box3}>
                    <div style={{ color: '#7C869B', marginLeft: '25px', fontSize: '12px' }}>
                      <FormattedMessage id={airportData?.name || '-'} defaultMessage={airportData?.name} />
                    </div>
                    <div className={scheduleStyle.aeroStyle2}>
                      <FormattedMessage id={useCalendarData?.title || '-'} defaultMessage={useCalendarData?.title} />
                    </div>
                    <div style={{ color: '#7C869B', margin: '10px 0 0 25px' }}>
                      <img className={scheduleStyle.imgstyle1} src="https://cdn-icons-png.flaticon.com/128/1827/1827463.png" alt="Aerosimple" />
                      <span>
                      {slot_duration}
                        {' Min '}
                      </span>
                      {init.noSlot && !available_time_slots?.length > 0 && (
                        <p style={{ marginTop: '10px' }}>
                          <FormattedMessage
                            id="scheduling.no_available_slots"
                            defaultMessage="No slots are available on this date. Please pick another date."
                          />
                        </p>
                      )}
                      {logData?.settings?.noOfDaysToMandate ? (
                      <div>
                        <span style={{ fontSize: '16px', color: '#3A61A8', fontWeight: '600' }}>Note: </span>
                        <FormattedMessage
                          tagName="span"
                          id="adp_settings.functionality.skill.test.mandate"
                          defaultMessage={`Due to the mandatory wait time (${logData?.settings?.noOfDaysToMandate} Days),
                           earlier dates are unavailable.`}
                        />
                      </div>
                    ): ''}
                    </div>
                  </div>
                </div>
                {useCalendarData?.id && slot_duration && (
                  <>
                    <div>
                      <div className={scheduleStyle.title}>
                        <FormattedMessage id="scheduling.title" defaultMessage="Select date & time" />
                      </div>
                      <div className={scheduleStyle.CalendarStyle}>
                        <Calendar
                          date={schedule_data?.selected_date}
                          dateFormat="yyyy-MM-DD"
                          onChange={(e) => { handleDateChange(useCalendarData, airportData, e, true); setInit({ ...init, noSlot: true }); }}
                          color="#3A61A8"
                          disabledDay={(current) => {
                            const customDate = moment().format('MM-DD-YYYY');
                            const nextMonth = moment().add(1, 'month').startOf('month');
                            return (
                              current
                              && (useDisableDates.includes(current) || current < moment(customDate, 'MM-DD-YYYY')
                               || reSchedule && logData?.settings?.is_reschedule_within_month && current >= nextMonth)
                            );
                          }}
                          disabledDates={useDates}
                          style={{ fontSize: '0.9rem' }}
                          onShownDateChange={handleNavigate}
                        />
                      </div>
                    </div>
                    <div className={scheduleStyle.thirdbox}>
                      <p className={scheduleStyle.thirdbox1}>
                        {moment(schedule_data?.selected_date).format('dddd, MMMM D')}
                      </p>
                      <div className={scheduleStyle.useTimeSty}>
                      {!hasToday && available_time_slots.map((time) => {
                          const timeInMinutes = timeToMinutes(time);
                          let disabled = false;
                          for (let i = 0; i < startTimeInMinutes.length; i++) {
                              const startTime = startTimeInMinutes[i];
                              const endTime = endTimeInMinutes[i];
                              const finalblockedDate = new Date(blockedDates[i]);
                              const finalSelectedDate = new Date(schedule_data?.selected_date);
                              const isSame = finalblockedDate.getUTCFullYear() === finalSelectedDate.getFullYear()
                                && finalblockedDate.getUTCMonth() === finalSelectedDate.getMonth()
                                && finalblockedDate.getUTCDate() === finalSelectedDate.getDate();
                              if (isSame && timeInMinutes >= startTime && timeInMinutes <= endTime) {
                                  disabled = true;
                                  break; // Exit loop early if disabled is true
                              }
                          }
                          return (
                            <div className={`${styles.smallBox} ${selected_time_slot === time ? styles.activeSlat : ''}`}
                            role="button" tabIndex={0}
                              onClick={() => !disabled && handleSelectSlot(time)} onKeyPress={() => !disabled && handleSelectSlot(time)}
                              style={{ cursor: disabled ? 'not-allowed': 'pointer', borderColor: disabled ? 'gray' : '#3a61a8' }}
                            >
                              <span style={{ color: disabled && 'gray' }}>
                                {time}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '2%', justifyContent: 'flex-end', padding: '15px', borderTop: '1px solid rgb(218,220,224)' }}>
          <Button
            action="danger"
            onClick={() => (setScheduleModal(false))}
            translationID="training.module.cancel"
            defaultText="Cancel"
          />
          <Button
            action="secondary"
            onClick={() => {
              handleSaveUpload();
              setScheduleModal(false);
            }}
            translationID="wildlife.form.submit"
            defaultText="Submit"
          />
        </div>
      </Modal>
      )}
      {!(useCalendarData?.id && slot_duration) && actionScheduleFetch?.success && (
        <Modal showIn={scheduleModal} width="40%" minHeight="20%" onClose={() => setScheduleModal(false)}>
          <div style={{ display: 'flex', borderBottom: '1px solid #dadce0', padding: '15px' }}>
            <h4 style={{ margin: '20px', fontWeight: '600' }}>
              <FormattedMessage
                id="scheduling.category.not_configured"
                defaultMessage="Airport has not set up a calendar schedule for this category of permit.
                 Kindly contact your admin for further information."
              />
            </h4>
          </div>
          <div style={{ display: 'flex', gap: '2%', justifyContent: 'flex-end', padding: '15px', borderTop: '1px solid rgb(218,220,224)' }}>
            <Button
              action="danger"
              onClick={() => setScheduleModal(false)}
              translationID="training.module.cancel"
              defaultText="Cancel"
            />
          </div>
        </Modal>
      )}
      {(actionDetails?.suspend?.openSuspendModal
      || actionDetails?.revoke?.operRevokeModal
      || actionDetails?.reactive?.openReactive) && (
        <SuspendRevokeComp
          handleAllStateValue={handleAllStateValue}
          actionDetails={actionDetails}
          updateId={match.params.id}
          adpDetails={adpDetails}
          avpDetailsPage={avpDetailsPage}
          getLatestAvpDetails={getLatestAvpDetails}
          handleGetLatestADPDetails={handleGetLatestADPDetails}
        />
      )}
      {/* PAYMENT MODAL */}
      <Modal
        showIn={paymentModal && profile?.portal_airport?.airport_settings?.payment_tracking !== 'TNS'}
        onClose={() => setPaymentModal(false)}
        width="auto" minHeight="150px"
        disableOutsideClick
      >
        <PaymentPage
          paymentData={invoiceObject?.grandTotal}
          profileCurrency={profile?.portal_airport?.airport_settings?.currency || '$'}
          handelNavigation={handleSkip}
          handlePayment={handlePayment}
          isDetail
          airportSettings={profile?.portal_airport?.airport_settings}
          paymentModule={paymentModule}
        />
      </Modal>

      {/* OFFLINE PAYMENT MODAL */}
      <Modal
        showIn={offlineModal} onClose={() => setOfflineModal(false)}
        width="350px" minHeight="150px" disableOutsideClick closeIcon
        title="Offline Payment" titleId="offline_payment"
        btnList={[
          { id: 'training.module.cancel', label: 'Cancel', action: 'tertiary', onClick: () => setOfflineModal(false) },
          { id: 'training.module.confirm', label: 'Confirm', action: 'secondary', onClick: () => handleOfflinePayment() }
        ]}
      >
        <div style={{ padding: '20px' }}>
          {(() => {
            const currency = profile?.portal_airport?.airport_settings?.currency || '$';
            const amount = `${currency}${invoiceObject.grandTotal.toFixed(2)}`;
            return (
              <FormattedMessage
                id="adp.offline_invoice"
                defaultMessage={`${amount} will be invoiced.`}
                tagName="h5"
              />
            );
          })()}
        </div>
      </Modal>

      {/* REFUND MODAL */}
      <Modal
        showIn={refundPopup} closeIcon
        disableOutsideClick
        width="554px" minHeight="150px"
        onClose={() => setRefundPopup(false)}
      >
        {renderRefundedDetails()}
      </Modal>

      {/* UPDATE REQUIRED DOCUMENT DATE */}
      <Modal
        showIn={updateDocumentsDate} onClose={() => handleDocDateModal(false)}
        width="943px" minHeight="150px" disableOutsideClick closeIcon
        title={'Update Documents/Dates'} titleId="update_documents_expired_date"
        btnList={[
          { id: 'training.module.cancel', label: 'Cancel', action: 'tertiary', onClick: () => handleDocDateModal(false) },
          { id: 'module.adp.update_documents', label: 'Update Documents', action: 'secondary', onClick: () => handleSaveDocuments() }
        ]}
      >
        <div className={styles.modalBody}>
          <UpdateRequiredDocuments
            reqAttachmentFields={logData?.schema?.default_fields?.required_attachements|| []}
            updateDocuments={updateDocuments}
            handleCloseDocumentModal={() => setUpdateDocuments({ ...updateDocuments, openDocumentModal: false })}
            handleUpdateDocuments={handleSetAttachments}
            answers={updateDocuments}
            customFields={[]}
            logData={logData}
            documentList={(() => expiringAttachments?.map(key => key.attachment_id)?.join(','))()}
          />
        </div>
      </Modal>

      {/* CANCEL PERMIT MODAL */}
      <Modal
        showIn={cancelDetails?.openCancelPopup}
        onClose={() => handleCancelDetails({ ...cancelDetails, openCancelPopup: false, cancelShowError: false, cancelRemarks: '' })}
        width="554px"
        minHeight="150px"
        centered
      >
        <div className={badgeStyles.newTask}>
          <div
            className={badgeStyles.closeicon}
            style={{ padding: '15px 15px 0px 15px' }}
          >
            <FormattedMessage
              tagName="p"
              id="adp.log.cancel.application"
              defaultMessage="Cancel Permit Confirmation"
            />
            <Clickable onClick={() => handleCancelDetails({ ...cancelDetails, openCancelPopup: false, cancelShowError: false, cancelRemarks: '' })}>
              <div style={{ cursor: 'pointer' }}>X</div>
            </Clickable>
          </div>
          <div className={badgeStyles.subHeading} style={{ fontWeight: '500' }}>
            <PulpoField
              key="cancelRemarks"
              id="cancelRemarks"
              type="string"
              isRequired
              translationID="asset_registry.table.front_display"
              title="Please provide reason for cancellation"
              widget={{ type: 'textarea' }}
              handleValueChange={a => handleCancelDetails({ ...cancelDetails, cancelRemarks: a })}
              answer={''}
              handleFieldErrorChanged={() => ({})}
              style={{ fontSize: '16px' }}
              className={styles.defaultFontSize}
              showFieldErrors={!cancelDetails?.cancelRemarks && cancelDetails?.cancelShowError}
            />
           {logData.status !== 3 && renderCancellationMessage()}
          </div>
          <div
            className={badgeStyles.notefooter}
            style={{ justifyContent: 'flexEnd', gap: '3%' }}
          >
            <Button
              action="tertiary"
              onClick={() => handleCancelDetails({ ...cancelDetails, openCancelPopup: false, cancelShowError: false, cancelRemarks: '' })}
              translationID="todo.newTask.cancel"
              defaultText="Cancel"
            />
            <div className={badgeStyles.saveWrapper1}>
              <Button
                onClick={() => handleCancellationOfPermit()}
                translationID="adp.application.revoke.submit"
                defaultText="Submit"
                action="secondary"
                disabled={adpAvpCancelAplicationAction?.loading || false}
              />
            </div>
          </div>
        </div>
      </Modal>

      {/* View Receipts */}
      <Modal
        showIn={viewReceipts} onClose={() => handleViewReceipts(false)}
        title={'Receipt List'} closeIcon disableOutsideClick
        width="350px" minHeight="100px"
        btnList={[
          { id: 'module.adp.close', label: 'Close', action: 'tertiary', onClick: () => handleViewReceipts(false) }
        ]}
      >
        {renderReceipts()}
      </Modal>
      <Modal
        showIn={renewalFlow.popup} onClose={() => handleCloseRenewPopup()}
        width="400px" minHeight="100px" disableOutsideClick closeIcon
        title="Confirmation" titleId="lease.tenants.steps.step5.confirmation"
        btnList={[
          { id: 'forms.darft.no', label: 'No', action: 'tertiary', onClick: () => handleCloseRenewPopup() },
          { id: 'forms.darft.yes', label: 'Yes', action: 'secondary', onClick: () => handleSubmitRenewalForm(renewalFlow.appID) }
        ]}
      >
        <div style={{ padding: '15px 30px' }}>
          <FormattedMessageWithClass
            tagName="h5"
            id="renewal.confirmation.permit"
            defaultMessage="Are you sure you want to renew this Permit?"
          />
        </div>
      </Modal>
      <Modal
        showIn={renewalFlow.reDirect} onClose={() => handleCloseRedirect()}
        width="400px" minHeight="100px" disableOutsideClick closeIcon
        title="Renewal application" titleId="note"
        btnList={[
          { id: 'close', label: 'Close', action: 'tertiary', onClick: () => handleCloseRedirect() }
        ]}
      >
        <div style={{ padding: '15px 30px' }}>
          <FormattedMessageWithClass
            tagName="h5"
            id="renewal.permit.message"
            defaultMessage="Application renewal has been initiated. Applicant needs to fill out the required details."
          />
        </div>
      </Modal>
    </>
  );
};
export default withRouter(Detail);
